// FontAwesome Pro - Solid (fas)
import {
  IconDefinition,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUpRightFromSquare,
  faBars,
  faBell,
  faCalendar,
  faCalendarXmark,
  faCamera,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCircleCheck,
  faCircleHalfStroke,
  faCircleMinus,
  faCirclePause,
  faCirclePlay,
  faCircleQuestion,
  faCircleXmark,
  faClock,
  faCloudArrowUp,
  faCode,
  faCommentSms,
  faCopy,
  faCrown,
  faCube,
  faEnvelope,
  faEyeLowVision,
  faFileLines,
  faFire,
  faGamepad,
  faGear,
  faGift,
  faHeart,
  faHourglassEnd,
  faHouse,
  faLink,
  faList,
  faLock,
  faMagnifyingGlass,
  faMinus,
  faOctagonXmark,
  faPaperPlane,
  faPaste,
  faPhone,
  faPlay,
  faPlus,
  faRankingStar,
  faReceipt,
  faRepeat,
  faRightFromBracket,
  faRightLeft,
  faRotate,
  faRotateRight,
  faShare,
  faSkullCrossbones,
  faStar,
  faTableCells,
  faThumbsUp,
  faTicket,
  faTrophy,
  faTruckFast,
  faTurnUp,
  faUpload,
  faUser,
  faVideo,
  faWaveform,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';

/**
 * Single source of truth pairing each supported icon name (as used via JSON)
 * with its FontAwesome definition. The list, type, and definitions below are
 * all derived from this map, so a name can never drift out of sync with its definition.
 */
export const FasIconMap = {
  'fas:arrow-down': faArrowDown,
  'fas:arrow-left': faArrowLeft,
  'fas:arrow-right': faArrowRight,
  'fas:arrow-up-right-from-square': faArrowUpRightFromSquare,
  'fas:bars': faBars,
  'fas:bell': faBell,
  'fas:calendar': faCalendar,
  'fas:calendar-xmark': faCalendarXmark,
  'fas:camera': faCamera,
  'fas:check': faCheck,
  'fas:chevron-down': faChevronDown,
  'fas:chevron-left': faChevronLeft,
  'fas:chevron-right': faChevronRight,
  'fas:circle': faCircle,
  'fas:circle-check': faCircleCheck,
  'fas:circle-half-stroke': faCircleHalfStroke,
  'fas:circle-minus': faCircleMinus,
  'fas:circle-pause': faCirclePause,
  'fas:circle-play': faCirclePlay,
  'fas:circle-question': faCircleQuestion,
  'fas:circle-xmark': faCircleXmark,
  'fas:clock': faClock,
  'fas:cloud-arrow-up': faCloudArrowUp,
  'fas:code': faCode,
  'fas:comment-sms': faCommentSms,
  'fas:copy': faCopy,
  'fas:crown': faCrown,
  'fas:cube': faCube,
  'fas:envelope': faEnvelope,
  'fas:eye-low-vision': faEyeLowVision,
  'fas:file-lines': faFileLines,
  'fas:fire': faFire,
  'fas:gamepad': faGamepad,
  'fas:gear': faGear,
  'fas:gift': faGift,
  'fas:heart': faHeart,
  'fas:hourglass-end': faHourglassEnd,
  'fas:house': faHouse,
  'fas:link': faLink,
  'fas:list': faList,
  'fas:lock': faLock,
  'fas:magnifying-glass': faMagnifyingGlass,
  'fas:minus': faMinus,
  'fas:octagon-xmark': faOctagonXmark,
  'fas:paper-plane': faPaperPlane,
  'fas:paste': faPaste,
  'fas:phone': faPhone,
  'fas:play': faPlay,
  'fas:plus': faPlus,
  'fas:ranking-star': faRankingStar,
  'fas:receipt': faReceipt,
  'fas:repeat': faRepeat,
  'fas:right-from-bracket': faRightFromBracket,
  'fas:right-left': faRightLeft,
  'fas:rotate': faRotate,
  'fas:rotate-right': faRotateRight,
  'fas:share': faShare,
  'fas:skull-crossbones': faSkullCrossbones,
  'fas:star': faStar,
  'fas:table-cells': faTableCells,
  'fas:thumbs-up': faThumbsUp,
  'fas:ticket': faTicket,
  'fas:trophy': faTrophy,
  'fas:truck-fast': faTruckFast,
  'fas:turn-up': faTurnUp,
  'fas:upload': faUpload,
  'fas:user': faUser,
  'fas:video': faVideo,
  'fas:waveform': faWaveform,
  'fas:xmark': faXmark,
} satisfies Record<`fas:${string}`, IconDefinition>;

/**
 * Generated type from the supported icon names.
 */
export type FasIcons = keyof typeof FasIconMap;

/**
 * The Supported Icon Names used via JSON.
 */
export const FasList = Object.keys(FasIconMap) as readonly FasIcons[];

/**
 * All FontAwesome Solid Icons available for the system
 * to use with Material Design are defined here.
 */
export const FasIconDefinitions: IconDefinition[] = Object.values(FasIconMap);
